import { QuickLinksCard } from '@features/workspace/components/shared/quick-links-card';

export function CreditQuickLinks() {
  const properties: Array<any> = [
    { link: '#', header: '??', text: 'Access link' },
    { link: '#', header: '??', text: 'Access link' },
    { link: '#', header: '??', text: 'Access link' },
    { link: '#', header: '??', text: 'Access link' },
  ];

  return (
    <QuickLinksCard
      header="Credit quick access service requests"
      properties={properties}
    />
  );
}
